/***************************************************************************/
"use client";
/***************************************************************************/

import { cn } from "../../../utils/css";
import { ButtonGroup } from "../button-group";

const FormActions: typeof ButtonGroup = ({ className, ...props }) => {
  return <ButtonGroup className={cn("pt-2", className)} {...props} />;
};

export { FormActions };
